<template>
  <div class="message">
    <h3>我的消息</h3>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="我的消息" name="first">
        <div class="box">
          <table>
            <thead>
              <tr>
                <th style="width: 220px; padding-left: 26px">发件人</th>
                <th style="width: 50%">公司</th>
                <th style="width: 350px">部门/职务</th>
                <th style="width: 250px">发送时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td style="padding-left: 26px">{{ item.name }}</td>
                <td>{{ item.company }}</td>
                <td>{{ item.department }}</td>
                <td>{{ item.datetime }}</td>
                <td>
                  <div>
                    <span @click="open()">查看</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="item">
            <!--分页 -->
            <div class="pagination">
              <span>共68条</span>
              <el-pagination
                class="explore_right_pages"
                layout="prev, pager, next"
                :current-page="currentPage4"
                @current-change="handleCurrentChange"
                :page-size="5"
                :total="68"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="收到得名片" name="second">
        <div class="businessCard">
          <div class="card_box" v-for="(item,index) in card" :key="index">
            <h3>焦小润</h3>
            <p>山西太重煤机煤矿装备成套有限公司</p>
            <p>采购部</p>
            <p>经理</p>
            <p>18766286565</p>
            <p>chen1350537@163.com</p>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "second",
      value: "",
      currentPage4: 1,
      tableData: [
        {
          name: "赵六",
          company: "XXXXX媒体有限责任公司",
          department: "记者",
          datetime: "2020-11-16 14:23",
        },
        {
          name: "赵六",
          company: "XXXXX媒体有限责任公司",
          department: "记者",
          datetime: "2020-11-16 14:23",
        },
        {
          name: "赵六",
          company: "XXXXX媒体有限责任公司",
          department: "记者",
          datetime: "2020-11-16 14:23",
        },
      ],
      card:[
          {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
            {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
            {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
            {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
            {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
           {
              name:'焦筱润',
              company:'山西太重煤机煤矿装备成套有限公司',
              department:'采购部门',
              postion:'经理',
              iphone:'18295960945',
              email:'247943541@qq.com'
          },
      ]
    };

  },
  create() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.message {
  margin: 17px 26px 20px 26px;
  box-sizing: border-box;
  padding: 18px 26px 0 26px;
  background: white;
  height: 845px;
  
  .box {
    // border: 1px solid rgb(92, 0, 221);
    height: 724px;
    position: relative;
    table {
      margin: 15px 0px 0px 0px;
      border-collapse: collapse;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      border-radius: 3px 3px 0px 0px;
      overflow: hidden;
      thead {
        //width: 100%;
        background: #006fb8;
        border-radius: 4px 4px 0px 0px;
        text-align: left;
        tr {
          height: 36px;
          color: rgba(255, 255, 255, 0.85);
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 200px;
            color: white;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      tbody {
        tr {
          height: 58px;
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: left;
            height: 58px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
            .inut {
              display: block;
              width: 35px;
              height: 24px;
              border: 1px solid #e0e0e0;
              line-height: 24px;
              color: #666666;
              margin-left: 25px;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .leaseCount {
        width: 100px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }

    .item {
      // height: 40px;
      // background-color: skyblue;
      position: absolute;
      right: 0px;
      bottom: 0px;
    }
    .pagination {
      // border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
      //   margin-top: 30px;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
  .businessCard {
    display: flex;
    justify-content: space-between;
    align-content: flex-start;
    flex-wrap: wrap;
    .card_box {
      width: 252px;
      height: 224px;
      border: 1px solid #e0e0e0;
      margin-bottom: 26px;
      h3 {
        position: relative;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        padding-left: 15px;
        margin-bottom: 26px;
        margin-top: 18px;
      }
      h3::before {
        content: "";
        position: absolute;
        width: 2px;
        height: 17px;
        bottom: 2px;
        left: 0;
        background: #006fb8;
        border-radius: 2px;
      }
      p {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-left: 18px;
        margin-bottom: 9px;
      }
    }
  }
}
</style>
<style lang='scss' scoped >
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>